import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { BillAccountActionButtons, BillAccountCard } from '../../models/billing-overview.models';

@Component({
  selector: 'ds-bill-account-card',
  templateUrl: './bill-account-card.component.html',
  styleUrls: ['./bill-account-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BillAccountCardComponent {
  @Input() billAccountCard: BillAccountCard;
  @Input() showAccountNumberAndNickname = false;

  @Output() actionButtonEvent: EventEmitter<BillAccountCard> = new EventEmitter();
  @Output() viewAccountEvent: EventEmitter<BillAccountCard> = new EventEmitter();

  actionButtons = BillAccountActionButtons;

  constructor() {}
}
